import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { SetedUslugaStateData } from './types';

const initialState: SetedUslugaStateData = {
	data: {
		data: [],
		error: null,
	},
	loading: false,
	error: '',
};

export const fetchSetedUslugas = createAsyncThunk('api/fetchSetedUslugas', (action: string) =>
	api.fetchSetedUslugas(action),
);

const abonentSetedUslugasSlice = createSlice({
	name: 'setedUslugas',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchSetedUslugas.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchSetedUslugas.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchSetedUslugas.rejected, (state) => {
				state.loading = false;
				state.error = 'Ошибка при загрузке';
			});
	},
});

export default abonentSetedUslugasSlice.reducer;
